<template lang="pug">
div
  b-form.form-horizontal(@submit.prevent="updateBank")
    div(v-if="complaint.country === 'CL'")
      b-form-group(label="Nombre")
        b-form-input.form-control(v-model.trim="complaint.bank_account.name" data-vv-as="nombre" name="bank_account[name]" v-validate="'required|alpha_spaces|max:40'" required)
        span.has-error(v-show="errors.has('bank_account[name]')") {{ errors.first('bank_account[name]') }}
      b-form-group(label="RUT")
        b-form-input.form-control(v-model.trim="complaint.bank_account.rut" data-vv-as="rut" name="bank_account[rut]", v-rut:live="" v-validate="'required|rut|max:12'" required)
        span.has-error(v-show="errors.has('bank_account[rut]')") Ingrese un rut válido
      b-form-group(label="Banco")
        selectize(v-model="complaint.bank_account.bank" data-vv-as="banco" name="bank_account[bank]" v-validate="'required'" @input="account_types($event)")
          option(v-for="bank in banks" :value="bank" :key="bank") {{ bank }}
        span.has-error(v-show="errors.has('bank_account[bank]')") {{ errors.first('bank_account[bank]') }}
      b-form-group(label="Tipo de cuenta" v-b-tooltip.hover.leftbottom="accounts.length === 0 ? 'Debe seleccionar el banco primero' : ''")
        selectize(id="account-type" v-model="complaint.bank_account.account_type" data-vv-as="tipo de cuenta" name="bank_account[type]" v-validate="'required'" :disabled="accounts.length === 0")
          option(v-for="account in accounts" :value="account.code" :key="account.code") {{ account.description }}
        span.has-error(v-show="errors.has('bank_account[type]')") {{ errors.first('bank_account[type]') }}
      b-form-group(label="Número de cuenta")
        b-form-input.form-control(v-model.trim="complaint.bank_account.account_number" data-vv-as="número de cuenta" name="bank_account[number]" v-validate="'required|numeric|max:17'")
        span.has-error(v-show="errors.has('bank_account[number]')") {{ errors.first('bank_account[number]') }}
      b-form-group.text-center
        b-button(type="submit" variant="primary") {{ bank_button }}
    div(v-else-if="complaint.country === 'PE'")
      b-form-group(label="Tipo de documento")
        selectize(v-model="complaint.bank_account.document_type" data-vv-as="tipo de documento" name="bank_account[document_type]" v-validate="'required'")
          option(v-for="document in documents" :value="document" :key="document") {{ document }}
        span.has-error(v-show="errors.has('bank_account[document_type]')") {{ errors.first('bank_account[document_type]') }}
      b-form-group(label="Número de documento")
        b-form-input.form-control(v-model.trim="complaint.bank_account.document_number" data-vv-as="número de documento" name="bank_account[document_number]" v-validate="'required|numeric'")
        span.has-error(v-show="errors.has('bank_account[document_number]')") {{ errors.first('bank_account[document_number]') }}
      b-form-group(label="Nombre del titular")
        b-form-input.form-control(v-model.trim="complaint.bank_account.name" data-vv-as="nombre" name="bank_account[name]" v-validate="'required|alpha_spaces|max:40'" required)
        span.has-error(v-show="errors.has('bank_account[name]')") {{ errors.first('bank_account[name]') }}
      b-form-group(label="Correo")
        b-form-input.form-control(v-model="complaint.bank_account.email" v-validate="'required|email'" data-vv-as="correo" name="bank_account[email]" type="email" autocomplete="off")
        span.has-error(v-show="errors.has('bank_account[email]')") {{ errors.first('bank_account[email]') }}
      b-form-group(label="Banco")
        selectize(v-model="complaint.bank_account.bank" data-vv-as="banco" name="bank_account[bank]" v-validate="'required'")
          option(v-for="bank in banks" :value="bank" :key="bank") {{ bank }}
        span.has-error(v-show="errors.has('bank_account[bank]')") {{ errors.first('bank_account[bank]') }}
      b-form-group(label="Tipo de cuenta")
        selectize(v-model="complaint.bank_account.account_type" v-validate="'required'" data-vv-as="tipo de cuenta" name="bank_account[type]")
          option(v-for="account in accounts" :value="account.code" :key="account.code") {{ account.description }}
        span.has-error(v-show="errors.has('bank_account[type]')") {{ errors.first('bank_account[type]') }}
      b-form-group(label="Número de cuenta")
        b-form-input.form-control(v-model.trim="complaint.bank_account.account_number" data-vv-as="número de cuenta" name="bank_account[number]" v-validate="'required|numeric|max:17'")
        span.has-error(v-show="errors.has('bank_account[number]')") {{ errors.first('bank_account[number]') }}
      b-form-group(label="CCI")
        b-form-input.form-control(v-model.trim="complaint.bank_account.cci" data-vv-as="CCI" name="bank_account[cci]" v-validate="'required|numeric'")
        span.has-error(v-show="errors.has('bank_account[cci]')") {{ errors.first('bank_account[cci]') }}
      b-form-group.text-center
        b-button(type="submit" variant="primary") {{ bank_button }}
  b-modal(ref='bankModal' size="lg" hide-header hide-footer no-close-on-backdrop=true)
    div.modal-body
      p.text-center.cancellation-modal-success-icon
        icon(name="check" scale="5")
      p.text-center Hemos recibido sus datos bancarios exitosamente. Por favor revise su correo electrónico.
      br
      br
      p.text-center
        b-button.btn.btn-recorrido(@click="closeModal") Cerrar
</template>

<script>
import constants from '@/constants/Status.constants';
import Selectize from 'vue2-selectize';
import kexaApi from '@/services/apiService';
import { Validator } from 'vee-validate';
import { rutValidator } from 'vue-dni';
import $ from 'jquery';

export default {
  name: 'StatusBankAccountForm',
  props: {
    complaint: {},
  },
  data() {
    return {
      banks: constants.BANKS,
      documents: constants.DOCUMENTS,
      accounts: [],
    };
  },
  beforeMount() {
    Validator.extend('rut', rutValidator);
    if (this.complaint.bank_account === null) {
      this.complaint.bank_account = {};
    }
    if (this.complaint.country === 'PE') {
      let options = constants.ACCOUNTS;
      options = options.filter(word => word.code !== 0);
      this.accounts = options;
    } else if (this.complaint.country === 'CL' && this.complaint.bank_account.bank !== undefined) {
      this.account_types(this.complaint.bank_account.bank);
    }
  },
  components: {
    Selectize,
  },
  computed: {
    bank_button() {
      return (this.complaint.bank_account.name === undefined) ? 'Ingresar' : 'Actualizar';
    },
  },
  methods: {
    account_types(event) {
      if (['COOPEUCH', 'BANCO ITAU'].includes(event)) {
        this.accounts = constants.ACCOUNTS.filter(word => word.code !== 2);
      } else {
        this.accounts = constants.ACCOUNTS;
      }
      $('#account-type').selectize().clear();
      $('#account-type').selectize().clearOptions();
      $('#account-type').selectize().refreshOptions(false);
    },
    updateBank() {
      const $this = this;
      this.$validator.validateAll().then((valid) => {
        if (valid) {
          kexaApi.status_bank($this.$route.params.complaint_id, {
            bank_account: $this.complaint.bank_account,
          }).then(() => {
            $this.$refs.bankModal.show();
          }).catch(() => { });
        }
      });
    },
    closeModal() {
      this.$refs.bankModal.hide();
      this.$emit('fetchComplaint');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/forms/StatusBankAccountForm.vue